import { render, staticRenderFns } from "./DistrictEditModal.vue?vue&type=template&id=0e2c8eab&scoped=true&"
import script from "./DistrictEditModal.vue?vue&type=script&lang=js&"
export * from "./DistrictEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DistrictEditModal.vue?vue&type=style&index=0&id=0e2c8eab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2c8eab",
  null
  
)

export default component.exports